import type { LinesLoadableState } from './LinesLoadable.types';

export const initialState: LinesLoadableState = { list: [], hasMore: false };
